module.exports = __webpack_public_path__ + "static/img/V3-2.e1727a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/langPack/V3/V3-2.png
// module id = qwgU
// module chunks = 1